:host {
  display: block;
  background-color: var(--theme-primary-background);
  border-radius: var(--spacer-4) var(--spacer-1) var(--spacer-4) var(--spacer-4);
  padding: calc(var(--spacer-2) + 2px) var(--spacer-4);
  border: 1px solid var(--theme-button-border);
  word-break: break-word;
}

:host([background-color="tertiary"]) {
  background-color: var(--theme-tertiary-background);
}
